<template lang="pug">
  component.card(
    :is="(post || {}).link ? 'rogue-link' : 'div'"
    :to="(post || {}).link"
    draggable="false"
    :class="[condensed && 'condensed', !(post || {}).link && 'loading', horizontal && 'horizontal']"
  )
    StaticImage(
      :src="(post || {}).largeFeaturedImagePath || (post || {}).featuredImagePath || ''"
      :width="400"
      :alt="(post || {}).title ? post.title.rendered :''"
      :height="300"
      ssr
      lazy
    )
    .content
      .category(v-if="showCategory && (post || {}).category") {{ post.category.name || '&nbsp;' }}
      .post-title(v-if="post?.title" v-html="post.title.rendered" v-translate="THE_INDEX_TITLES_NS")
      slot
      .read-more {{ (post || {}).format === 'video' ? __('Watch Video') : __('Read More') }}
</template>
<script setup lang="ts">
import { THE_INDEX_TITLES_NS } from '../constants'

defineProps({
  post: {
    type    : Object,
    default : () => ({}),
  },
  condensed: {
    type    : Boolean,
    default : false,
  },
  showCategory: {
    default: true,
  },
  horizontal: {
    type    : Boolean,
    default : false,
  },
})
</script>
<style lang="scss" scoped>

.card {
  text-decoration: none;
  display: block;
}

.rg-img {
  margin-bottom: $space-xs;
  :deep(img) {
    object-position: top;
  }
}

.post-title {
  margin-bottom: $space-xs;
  font-size: $size-s;
  font-weight: bold;
  color: $color-black;
}

.condensed {
  .read-more, .category {
    display: none;
  }

  .rg-img {
    margin-bottom: $space-xxs;
  }

  .post-title {
    font-size: $size-xs;
  }
}

.content {
  text-decoration: none;
}

.horizontal {
  display: flex;
  align-items: flex-start;

  .rg-img {
    flex-basis: 142px;
    flex-grow: 0;
    flex-shrink: 0;
    height: 105px;
    width: 142px;
    padding-bottom: 0;
    overflow: hidden;
  }

  .category {
    display: none;
  }

  .read-more {
    font-size: $size-xxs;
    font-weight: $weight-bold;
  }

  .post-title {
    font-size: $size-xs;
    margin-bottom: $space-xxs;
  }

  .content {
    padding-left: $space-xs;
  }

  @include not-desktop() {
    .rg-img {
      height: 107px;
    }
    .read-more {
      font-weight: normal;
    }
  }
}

.category {
  font-size: $size-xs;
  text-transform: uppercase;
  color: $color-gray-dark;
  margin-bottom: $space-xxs;
}

.read-more {
  font-family: $font-condensed;
  font-size: $size-xs;
  color: $color-black;
  text-decoration: underline;
}

.loading {
  .rg-img, .post-title, .category, .read-more {
    background-color: $color-gray-light;
    color: $color-gray-light;
  }

  .read-more {
    opacity: 0.5;
    pointer-events: none;
  }
}

</style>
